import { makeAutoObservable, runInAction } from "mobx";
import { IMerchantOnboarding } from "../onboarding-types";
import OnboardingDataStore, { IMerchantOnboardingChanges, IOnboardingScreenStore } from "./onboarding-data-store";
import { ONBOARDING_STEPS } from "../constants";
import { OnboardingNavigationStore } from "./onboarding-navigation-store";
import onboardingMixPanelStore, {ONBOARDING_MIXPANEL_EVENT, ONBOARDING_BUTTON_TRACKABLE_TYPES} from "./onboarding-mixpanel-store";

class SetupReturnGuardStore implements IOnboardingScreenStore {
    private _changes: IMerchantOnboardingChanges = {};
    private _getModel(): IMerchantOnboarding | undefined {
        return this._onboardingDataStore.getModel();
    };
    private _stepName: ONBOARDING_STEPS = ONBOARDING_STEPS.SETUP_RETURN_GUARD;
    private _showContinueButton: boolean = false;
    private _isLoading: boolean = false;

    constructor(private _onboardingDataStore: OnboardingDataStore, private _navigationStore: OnboardingNavigationStore) {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    private get isReturnGuardVisibleMarkedAsDone(): boolean { return this._changes.is_return_guard_visible_marked_as_done ?? this._getModel()?.is_return_guard_visible_marked_as_done ?? false; }
    get addExtensionUIBlockURL(): string { return this._onboardingDataStore.addExtensionUIBlockURL; }
    get isLoading(): boolean { return this._isLoading; }

    public getUpdatedModel(): IMerchantOnboarding {
        return { ...this._getModel(), ...this._changes } as IMerchantOnboarding;
    }

    public getMixPanelData(): Record<string, any> {
        return this._changes;
    }

    public discardChanges(): void {
        this._changes = {};
    }

    public hasChanges(): boolean {
        return Object.keys(this._changes).length > 0;
    }

    public isComplete(): boolean {
        return this.isReturnGuardVisibleMarkedAsDone;
    }

    public setIsReturnGuardVisibleMarkedAsDone(v: boolean): void {
        this._changes.is_return_guard_visible_marked_as_done = v;
    }

    public previousStep(): void {
        this._navigationStore.previousStep();
    }

    public async nextStep(): Promise<void> {
        this._isLoading = true;

        await this._onboardingDataStore.save(this._stepName);
        runInAction(() => {
            this._navigationStore.nextStep();
            this._isLoading = false;
        })
    }

    public get showContinueButton(): boolean {
        return this._showContinueButton;
    }

    public onSetupClick(): void {
        this.setIsReturnGuardVisibleMarkedAsDone(true);
        onboardingMixPanelStore.trackEvent(ONBOARDING_MIXPANEL_EVENT.ONBOARDING_BUTTON_CLICKED,
            {
                from: this._stepName,
                button: ONBOARDING_BUTTON_TRACKABLE_TYPES.ONBOARDING_SETUP_RETURN_GUARD_SETUP_NOW
            }
        );
        this._showContinueButton = true;
    }

    public async onSetupLaterClick(): Promise<void> {
        this.setIsReturnGuardVisibleMarkedAsDone(true);
        onboardingMixPanelStore.trackEvent(ONBOARDING_MIXPANEL_EVENT.ONBOARDING_BUTTON_CLICKED,
            {
                from: this._stepName,
                button: ONBOARDING_BUTTON_TRACKABLE_TYPES.ONBOARDING_SETUP_RETURN_GUARD_SETUP_LATER
            },
        );
        await this.nextStep();
    }
}

export default SetupReturnGuardStore;
